// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"137":"083de389","254":"b5358c92"}[chunkId] + ".css";
};